require('./helpers/bundle-manifest').register(JSON.parse("{\"9vqfN\":\"index.0a744015.js\",\"axpzy\":\"logo.8d344ba4.svg\"}"));